import { useState } from 'react'
import type { Quizfraga } from '../types'

export default function Quiz({ fragor }: { fragor: Quizfraga[] }) {
  const [index, setIndex] = useState(0)
  const [valt, setValt] = useState<number | null>(null)
  const [poang, setPoang] = useState(0)
  const [klar, setKlar] = useState(false)

  const fraga = fragor[index]
  const sista = index === fragor.length - 1

  const svara = (alternativIndex: number) => {
    if (valt !== null) return
    setValt(alternativIndex)
    if (alternativIndex === fraga.ratt_svar_index) setPoang((p) => p + 1)
  }

  const vidare = () => {
    if (sista) {
      setKlar(true)
    } else {
      setIndex((i) => i + 1)
      setValt(null)
    }
  }

  const borjaOm = () => {
    setIndex(0)
    setValt(null)
    setPoang(0)
    setKlar(false)
  }

  if (klar) {
    const alla = poang === fragor.length
    return (
      <div className="quiz-kort quiz-resultat">
        <div className="quiz-resultat-poang">
          {poang} / {fragor.length}
        </div>
        <p>
          {alla
            ? 'Alla rätt — snyggt jobbat!'
            : poang >= fragor.length / 2
              ? 'Bra jobbat! Gå gärna tillbaka till texten och titta på det du missade.'
              : 'Bra försök! Läs gärna kapitlet en gång till och testa igen.'}
        </p>
        <button type="button" className="knapp knapp-primar" onClick={borjaOm}>
          Gör om quizet
        </button>
      </div>
    )
  }

  const rattSvar = valt !== null && valt === fraga.ratt_svar_index

  return (
    <div className="quiz-kort">
      <div className="quiz-meta">
        <span>
          Fråga {index + 1} av {fragor.length}
        </span>
        <span className={`niva-badge niva-${fraga.niva}`} title={`Nivå ${fraga.niva}`}>
          {fraga.niva}
        </span>
      </div>
      <div className="quiz-matare" aria-hidden="true">
        <div style={{ width: `${(index / fragor.length) * 100}%` }} />
      </div>
      <p className="quiz-fraga">{fraga.fraga}</p>
      <div className="quiz-alternativ" role="group" aria-label="Svarsalternativ">
        {fraga.alternativ.map((alternativ, i) => {
          let klass = ''
          if (valt !== null) {
            if (i === fraga.ratt_svar_index) klass = 'ratt'
            else if (i === valt) klass = 'fel'
            else klass = 'dampad'
          }
          return (
            <button key={i} type="button" className={klass} disabled={valt !== null} onClick={() => svara(i)}>
              {alternativ}
            </button>
          )
        })}
      </div>
      {valt !== null && (
        <div className={`quiz-feedback ${rattSvar ? 'ratt' : 'fel'}`} role="status">
          <strong>{rattSvar ? 'Rätt svar!' : 'Inte riktigt.'}</strong>
          <p>{fraga.forklaring}</p>
        </div>
      )}
      {valt !== null && (
        <div className="quiz-fot">
          <button type="button" className="knapp knapp-primar" onClick={vidare}>
            {sista ? 'Visa resultat' : 'Nästa fråga'}
          </button>
        </div>
      )}
    </div>
  )
}
